const headerMenuCollapsable = document.querySelector('.header-menu-collapsable');
if (headerMenuCollapsable) {
  headerMenuCollapsable.addEventListener('click', function() {
    const collapsableClasses = this.classList
    if (collapsableClasses.contains('open')) {
      collapsableClasses.remove('open')
    } else {
      collapsableClasses.add('open')
    }
    const menuClasses = document.querySelector('.header-menu-mobile').classList
    if (menuClasses.contains('visible')) {
      menuClasses.remove('visible')
    } else {
      menuClasses.add('visible')
    }
  })
}

const menuItems = document.querySelectorAll('.menu-item-title')
menuItems.forEach(item => {
  item.addEventListener('click', function(e) {
    const classes = this.parentNode.classList
    const menuItems = this.parentNode.parentNode.childNodes;
    if (classes.contains('visible')) {
      classes.remove('visible')
    } else {
      menuItems.forEach(item => {
        if (item.classList.contains("visible")) {
          item.classList.remove("visible");
        }
      });
      classes.add('visible')
    }
  })
})


const menuLargeItems = document.querySelectorAll('.header-menu li');


menuLargeItems.forEach(item => {
    let timer;
    if (item.classList.contains('search-icon-container')) {
        return;
    }
    item.addEventListener('mouseenter', () => {
        clearTimeout(timer);
        timer = setTimeout(() => {
        item.querySelector('.header-submenu').style.display = 'flex';
        }, 700);
    });

    item.addEventListener('mouseleave', () => {
        clearTimeout(timer);
        timer = setTimeout(() => {
        item.querySelector('.header-submenu').style.display = 'none';
        }, 700);
    });
});